<template>
    <div class="language-switcher">
      <button 
        v-for="locale in availableLocales" 
        :key="locale.code" 
        @click="changeLanguage(locale.code)"
        :class="{ 'active': currentLocale === locale.code }"
        class="mx-2 font-medium">
        {{ locale.name }}
      </button>
    </div>
  </template>
  
  <script>
  import { trackLanguageChange } from '@/utils/gtm-tracking';
  
  export default {
    name: 'LanguageSwitcher',
    data() {
      return {
        availableLocales: [
          { code: 'en', name: 'EN' },
          { code: 'es', name: 'ES' }
        ]
      }
    },
    computed: {
      currentLocale() {
        return this.$i18n.locale;
      }
    },
    methods: {
      changeLanguage(locale) {
        const previousLocale = this.$i18n.locale;
        this.$i18n.locale = locale;
        localStorage.setItem('userLocale', locale);
        
        // Track language change
        trackLanguageChange(locale, previousLocale);
      }
    }
  }
  </script>
  
  <style scoped>
  .active {
    font-weight: bold;
    text-decoration: underline;
  }
  </style>